
import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import SignUp from "./component/userAuth/SignUp";
import Otp from "./component/userAuth/Otp";
import LogIn from "./component/userAuth/LogIn";
import ForgetPassword from "./component/userAuth/ForgetPasswrd/ForgetPassword";
import ForgetOtp from "./component/userAuth/ForgetPasswrd/ForgetOtp";
import ConfirmPassword from "./component/userAuth/ForgetPasswrd/ConfirmPassword";
import Home from "./component/HomePage/Home";
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import './index.css';
import ProfilePage1 from "./component/Profile/ProfilePage1";
import Myprofile from "./component/Profile/MyProfile";
import Bookings from "./component/Profile/Bookings";
import Quotations from "./component/Profile/Quotations";
import Transactions from "./component/Profile/Transactions";
import Blogs from "./component/Blog/Blogs";
import HelpMePlan from "./component/HomePage/HelpMePlan";
import LadakhDestinations from "./component/HomePage/LadakhDestinations";
import TripPackage from "./component/HomePage/TripPackage";
import PackageDestination from "./component/HomePage/PackageDestination";
import BlogInner from "./component/Blog/BlogInner";
import Faq from "./component/FooterComponents/Faq";
import ContactUs from "./component/Contact/ContactUs";
import CancellationPolicy from "./component/Policies/CancellationPolicy";
import PrivacyPolicy from "./component/Policies/PrivacyPolicy";
import TermsNConditions from "./component/Policies/TermsNConditions";
import AllPackages from "./component/AllPackages/AllPackages";
import BookOnline from "./component/Booking/BookOnline";
import Thankyou from "./component/ThankYouPAage/Thankyou";
import BookOnlineCarHotel from "./component/Booking/BookOnlineCarHotel";
import HotelCard from "./component/HomePage/HotelCard";
import BikePackage from "./component/HomePage/PackagesPage/BikePackage"
import CarPackage from "./component/HomePage/PackagesPage/CarPackage"
import DetailBikePackage from "./component/HomePage/PackagesPage/DetailBikePackage"
import HotelPackage from "./component/HomePage/PackagesPage/HotelPackage"
import DetailCarPackage from "./component/HomePage/PackagesPage/DetailCarPackage"
import DetailHotelPackage from "./component/HomePage/PackagesPage/DetailHotelPackage"
import AllDestinations from "./component/HomePage/AllDestinations"
import { Helmet } from "react-helmet-async";
import { SITE_URL } from "./component/Seo/seoConfig";

function ScrollToTopOnMount() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

// Renders the canonical link + og:url for every route from a single place,
// via react-helmet-async, so exactly one canonical tag exists per page even
// on routes that don't render a page-level <Seo> component. Previously this
// manipulated document.head directly; now that react-helmet-async owns the
// document head, it's rendered through Helmet instead so the two mechanisms
// never fight over the same <link> node or leave stale duplicates behind
// when navigating between routes.
function CanonicalTag() {
  const { pathname } = useLocation();

  // Canonical points to the clean path (no query string or hash),
  // and drops any trailing slash except for the root path.
  const cleanPath = pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;
  const href = `${SITE_URL}${cleanPath}`;

  return (
    <Helmet>
      <link rel="canonical" href={href} />
      <meta property="og:url" content={href} />
    </Helmet>
  );
}

function App() {
  return (
    <>
      <BrowserRouter>
        <ScrollToTopOnMount />
        <CanonicalTag />
        <Routes>
       
          <Route path="/" element={<Home />} />
          <Route path="/otp" element={<Otp />} />
          <Route path="/all-destinations" element={<AllDestinations />} />
          <Route path="/bike-package" element={<BikePackage />} />
          <Route path="/hotel-package" element={<HotelPackage />} />
          <Route path="/car-package" element={<CarPackage />} />
          <Route path="/login" element={<LogIn />} />
          <Route path="/my-profile" element={<Myprofile />} />
          <Route path="detail-bike-package/:id" element={<DetailBikePackage />} />
          <Route path="detail-hotel-package/:id" element={<DetailHotelPackage />} />
          <Route path="detail-car-package/:id" element={<DetailCarPackage />} />
          <Route path="/forget-password" element={<ForgetPassword />} />
          <Route path="/forget-otp" element={<ForgetOtp />} />
          <Route path="/confirm-password" element={<ConfirmPassword />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/profile-page" element={<ProfilePage1 />} />
          <Route path="/booking" element={<Bookings />} />
          <Route path="/quotation" element={<Quotations />} />
          <Route path="/transaction" element={<Transactions />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/plan-ladakh-trip" element={<HelpMePlan />} />
          <Route path="/ladakh-dest" element={<LadakhDestinations />} />
          {/* <Route path="/PackageDestination/:slug" element={<PackageDestination />} /> */}
          <Route path="/:slug" element={<PackageDestination />} />
          {/* <Route path="/TripPackages/:Name" element={<TripPackage />} /> */}
          <Route path="/trip-packages/:name" element={<TripPackage />} />
          <Route path="/BlogInner/:Id" element={<BlogInner />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/cancellation-policy" element={<CancellationPolicy />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-and-condition" element={<TermsNConditions />} />
          {/* <Route path="/AllPackages" element={<AllPackages />} /> */}
          <Route path="/all-packages" element={<AllPackages />} />
          <Route path="/book-online" element={<BookOnline />} />
          <Route path="/thankyou" element={<Thankyou />} />
          <Route path="/book-online-car-Hotel" element={<BookOnlineCarHotel />} />
          <Route path="/ladakh-stay" element={<HotelCard />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;

